import { MainMenu, SubMenuType } from 'rangeConfig/@types';
import platform from 'rangeConfig/shared/utils/platform';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import * as R from 'ramda';
import cabinetsProductListConfig from './productListConfig';
import withCategoryFilter from 'rangeConfig/shared/widgets/withCategoryFilter';
import baseCabinetImage from './images/base.jpg';
import wallCabinetImage from './images/wall.jpg';
import highCabinetImage from './images/high.jpg';
import openFrameImage from './images/open.jpg';
import BaseCabinetsTypeFilter from 'rangeConfig/knoxhult/widgets/typeFilters/BaseCabinetTypeFilter';
import withInlineMessage from 'rangeConfig/shared/widgets/withInlineMessage';
import CategoryAdditionalInlineMessage from 'components/ProductSidebar/CategoryWidget/CategoryAdditionalInlineMessage';
import WallCabinetTypeFilter from 'rangeConfig/knoxhult/widgets/typeFilters/WallCabinetTypeFilter';
import ChangeBaseCabinetStyle from 'rangeConfig/knoxhult/widgets/ChangeStyle/ChangeBaseCabinetStyle';
import ChangeWallCabinetStyle from 'rangeConfig/knoxhult/widgets/ChangeStyle/ChangeWallCabinetStyle';
import ChangeHighCabinetStyle from 'rangeConfig/knoxhult/widgets/ChangeStyle/ChangeHighCabinetStyle';
import ChangeOpenFramesStyle from 'rangeConfig/knoxhult/widgets/ChangeStyle/ChangeOpenFramesStyle';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import ChangeAllCabinetsStyle from 'rangeConfig/knoxhult/widgets/ChangeStyle/ChangeAllCabinetsStyle';
import { hideMobileFramesColorFilter } from 'rangeConfig/knoxhult/rules/hideMenuRules';

const baseCabinets = R.pipe(withCategoryFilter(['base-cabinets']));
const wallCabinets = R.pipe(withCategoryFilter(['wall-cabinets']));
const highCabinets = R.pipe(withCategoryFilter(['high-cabinets']));
const openFrames = R.pipe(withCategoryFilter(['open-frames']));

const cabinetOptions = () => {
  return [
    {
      id: 'base-cabinets',
      title: 'storageone.baseCabinetsMenuTitle',
      image: baseCabinetImage,
      widgets: [
        {
          id: 'change-base-cabinet-color',
          component: ChangeBaseCabinetStyle
        },
        {
          id: 'frame-type-filters',
          component: BaseCabinetsTypeFilter
        },
        {
          id: 'mirrored-cabinets-inline-message',
          component: withInlineMessage(
            'storageone.mirroredCabinetsInfoMessageDescription',
            false,
            'storageone.mirroredCabinetsInfoMessageTitle'
          )(CategoryAdditionalInlineMessage)
        },
        {
          id: 'base-cabinets-product-list',
          component: baseCabinets(withProducts(ProductList, cabinetsProductListConfig))
        }
      ]
    },
    {
      id: 'wall-cabinets',
      title: 'storageone.wallCabinetsMenuTitle',
      image: wallCabinetImage,
      widgets: [
        {
          id: 'change-wall-cabinet-color',
          component: ChangeWallCabinetStyle
        },
        {
          id: 'frame-type-filters',
          component: WallCabinetTypeFilter
        },

        {
          id: 'wall-cabinets-product-list',
          component: wallCabinets(withProducts(ProductList, cabinetsProductListConfig))
        }
      ]
    },
    {
      id: 'high-cabinets',
      title: 'storageone.highCabinetsMenuTitle',
      image: highCabinetImage,
      widgets: [
        {
          id: 'change-high-cabinet-color',
          component: ChangeHighCabinetStyle
        },
        {
          id: 'high-cabinets-product-list',
          component: highCabinets(withProducts(ProductList, cabinetsProductListConfig))
        }
      ]
    },
    {
      id: 'open-frames',
      title: 'storageone.openFramesMenuTitle',
      image: openFrameImage,
      widgets: [
        {
          id: 'change-open-frame-color',
          component: ChangeOpenFramesStyle
        },
        {
          id: 'open-frames-product-list',
          component: openFrames(withProducts(ProductList, cabinetsProductListConfig))
        }
      ]
    }
  ];
};
const widgets = {
  desktop: [],
  mobile: [
    {
      id: 'change-base-cabinet-color',
      component: ChangeAllCabinetsStyle,
      title: 'storageone.selectedProductChangeStyle',
      hidden: hideMobileFramesColorFilter
    },
    {
      id: 'base-cabinets-product-list',
      title: 'storageone.baseCabinetsMenuTitle',
      component: baseCabinets(withProducts(ProductSwiper, cabinetsProductListConfig))
    },
    {
      id: 'wall-cabinets-product-list',
      title: 'storageone.wallCabinetsMenuTitle',
      component: wallCabinets(withProducts(ProductSwiper, cabinetsProductListConfig))
    },
    {
      id: 'high-cabinets-product-list',
      title: 'storageone.highCabinetsMenuTitle',
      component: highCabinets(withProducts(ProductSwiper, cabinetsProductListConfig))
    }
  ]
};

const subMenu = {
  mobile: undefined,
  desktop: {
    type: SubMenuType.LIST,
    options: cabinetOptions()
  }
};

const mainMenu = (): MainMenu => {
  return {
    menuTitle: 'storageone.productListCabinetsTitle',
    behaviors: {
      productGroupEntered: [],
      productGroupExited: []
    },
    filters: [],
    widgets: widgets[platform],
    subMenu: subMenu[platform]
  };
};

export default mainMenu;
